import { bus } from '@core/events/eventSystem';
import constants from '@core/utils/constants';

class NotificationService {
  /**
   * Upload the device token to the dedicated broadcast API.
   * Pattern: Kiosk Project
   */
  async uploadDeviceToken(userId, token, countryCode) {
    if (!userId || !token) return;

    const requestId = `req_${Date.now().toString(36)}${Math.floor(Math.random() * 100000)}`;

    const payload = {
      requestId,
      emitter: '1bpay',
      userId: userId,
      token: token
    };

    if (countryCode && countryCode !== 'ANY') {
      payload.metadata = {
        country: countryCode
      };
    }

    console.log('[NotificationService] Uploading device token...', payload);

    bus.emit(constants.EVENTS.NETWORK.REQUEST, {
      id: requestId,
      url: constants.ENDPOINTS.SERVICES.ADD_TOKEN,
      method: 'POST',
      data: payload
    });

    // We don't necessarily need to wait for a response for this background task,
    // but the bus will handle the network call.
  }
}

export const notificationService = new NotificationService();
